import React from 'react';

const StopAccessIcon = function StopAccessIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path opacity="0.959" fillRule="evenodd" clipRule="evenodd" d="M9 1.75431C4.99832 1.75431 1.75431 4.99831 1.75431 8.99999C1.75431 13.0017 4.99832 16.2457 9 16.2457C13.0017 16.2457 16.2457 13.0017 16.2457 8.99999C16.2457 4.99831 13.0017 1.75431 9 1.75431ZM0 8.99999C0 4.02943 4.02944 0 9 0C13.9706 0 18 4.02943 18 8.99999C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 8.99999Z" fill="#001760" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.4227 3.8182L3.81861 15.4223L2.57812 14.1818L14.1822 2.57771L15.4227 3.8182Z" fill="#001760" />
    </svg>
  );
};
export default StopAccessIcon;
